import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  InputGroup,
  Row,
  Form,
  Modal,
} from "react-bootstrap";
import { base_url, postHeader } from "../../../../../Helpers/request";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../../../Components/Loader";
import Heading from "../ui/Heading";
import { useSelector } from "react-redux";

function SignupTo() {
  const history = useHistory();
  const currencycode = useSelector(
    (state) => state.persistedReducer.home.currencycode
  );
  const [newsletteremail, setNewsletteremail] = useState("");
  const [loader, setLoader] = useState(false);
  const newsletter = (e) => {
    e.preventDefault();
    setLoader(true);
    const data = {
      currency_code: currencycode,
      email: newsletteremail,
    };
    axios
      .post(base_url + "/common/subscribe_newsletter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setNewsletteremail("");
          return swal(res.data.message, "", "success");
        } else {
          setLoader(false);
          return swal(res.data.message, "", "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };
  return (
    <section className="rcs_signup_to_section py-5">
      <Container>
        <div class="main_heading">
          <h2>Sign up to be a Belgium WebNet Insider</h2>
        </div>

        <div className="rcs_signup_to_input_field text-center">
          <p>Become a preferred subscriber and get a special offer on your purchase.</p>
          <Form className="gs_news_form w-100" onSubmit={newsletter}>
            <InputGroup>
              <FormControl
                aria-label="Recipient's username"
                type="email"
                value={newsletteremail}
                placeholder="Your email address"
                required
                onChange={(e) => setNewsletteremail(e.target.value)}
              />
              <Button
                className="btn outline-base-btn large"
                type="submit"
                id="button-addon2"
              >
                Subscribe
              </Button>
            </InputGroup>
          </Form>

          <p className="news-txt">By signing up you confirm that you have read the Privacy Policy and agree that your email will be collected and used for the purposes of sending news, promotions and updates via email. You can withdraw your consent at any time by unsubscribing.</p>
        </div>
      </Container>

      <Modal show={loader}>
        <Loader />
      </Modal>
    </section>
  );
}

export default SignupTo;
